import ComponentFactory from '../../../shared/utils/ComponentFactory';
import PropTypes from 'prop-types';
import React from 'react';
import { actions as settingsActions } from '../../../actions/SettingsActions';
import { actions as sessionActions } from '../../../actions/SessionActions';
import { actions as formActions } from '../../../actions/FormActions';
import _ from 'lodash';

export default ComponentFactory({
        propTypes: {
            reservation: PropTypes.shape({
                date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
                time: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
                party: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            }),
            errors: PropTypes.object,
            options: PropTypes.object,
            reserveResponse: PropTypes.object,
            errorResponse: PropTypes.object,
            step: PropTypes.number,
            stepOptions: PropTypes.object,
            onClose: PropTypes.func,
            isCustomDesign: PropTypes.bool,
            restaurant: PropTypes.object,
            interactions: PropTypes.object
        },

        getDefaultProps() {
            return {
                errors: {}
            };
        },

        componentWillMount() {
            const { formActions, sessionActions, settingsActions, reservation, options, reserveResponse, errorResponse,
                step, stepOptions, isCustomDesign, errors, interactions } = this.props;
            const { date, time, party, location } = reservation;

            formActions.initForm({reservation: {date, time, party, location}, options, errors});
            sessionActions.reservationResponse({reserveResponse, errorResponse});
            sessionActions.setSteps({step, stepOptions});
            sessionActions.setInteractions({interactions});
            settingsActions.initSettings({isCustomDesign});
        },

        componentWillUpdate(nextProps) {
            const { formActions, sessionActions, settingsActions, errors, reserveResponse, errorResponse, step, isCustomDesign } = this.props;
            if (!_.isEqual(nextProps.errors, errors)) {
                formActions.initForm({errors: nextProps.errors});
            }
            if (!_.isEqual(nextProps.reserveResponse, reserveResponse) || !_.isEqual(nextProps.errorResponse, errorResponse)) {
                sessionActions.reservationResponse({reserveResponse: nextProps.reserveResponse, errorResponse: nextProps.errorResponse});
            }
            if (nextProps.step !== step) {
                sessionActions.setSteps({step: nextProps.step, stepOptions: nextProps.stepOptions});
            }
            if (nextProps.isCustomDesign !== isCustomDesign) {
                settingsActions.initSettings({isCustomDesign: nextProps.isCustomDesign});
            }
        },

        render() {
            return React.Children.only(React.cloneElement(this.props.children, {...this.props}));
        },

        _onSubmit() {
            const { onSave, form } = this.props;
            const { reservation, errors, options } = form;
            onSave && onSave({reservation, errors, options});
        },

        _closePopup() {
            const { onClose, form } = this.props;
            const { reservation, errors, options } = form;
            sessionActions.closeDetailsForm();
            onClose && onClose({reservation, errors, options});
        },

        _onDone() {
            const { onClose } = this.props;
            sessionActions.closeDetailsForm();
            onClose && onClose();
        },

        _onUpdate({value, type}) {
            const { formActions, onUpdate } = this.props;
            formActions.updateField({value, type});
            onUpdate && onUpdate({value, type});
        },

        _onSmsValidation(code) {
            const { onPublish } = this.props;
            onPublish && onPublish({type: 'validation', data: {code}});
        },

        _onBack() {
            const { onPublish } = this.props;
            onPublish && onPublish({type: 'back', data: {}});
        }
    }, state => ({form: state.seatingForm, session: state.seatingSession, settings: state.seatingSettings, locations: _.get(state, 'locations.locations')}),
    {formActions, sessionActions, settingsActions});